export default {"src":"/_next/static/media/Group-25840.b02769da.svg","height":126,"width":126};